module.exports = __webpack_public_path__ + "img/bookshelf.bf4bd07e.svg";